/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamExamidLangsQueryResponse,
  GetApiV1ExamExamidLangsPathParams,
  GetApiV1ExamExamidLangsQueryParams,
  GetApiV1ExamExamidLangs401,
  GetApiV1ExamExamidLangs404,
  GetApiV1ExamExamidLangs500,
} from "../../types/examEvaluationController/GetApiV1ExamExamidLangs.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamExamidLangs } from "../../clients/examEvaluationController/getApiV1ExamExamidLangs.ts";

export const getApiV1ExamExamidLangsQueryKey = (
  examId: GetApiV1ExamExamidLangsPathParams["examId"],
  params?: GetApiV1ExamExamidLangsQueryParams,
) =>
  [
    { url: "/api/v1/exam/:examId/langs", params: { examId: examId } },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1ExamExamidLangsQueryKey = ReturnType<
  typeof getApiV1ExamExamidLangsQueryKey
>;

export function getApiV1ExamExamidLangsQueryOptions(
  examId: GetApiV1ExamExamidLangsPathParams["examId"],
  params?: GetApiV1ExamExamidLangsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamExamidLangsQueryKey(examId, params);
  return queryOptions<
    GetApiV1ExamExamidLangsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamExamidLangs401
      | GetApiV1ExamExamidLangs404
      | GetApiV1ExamExamidLangs500
    >,
    GetApiV1ExamExamidLangsQueryResponse,
    typeof queryKey
  >({
    enabled: !!examId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamExamidLangs(examId, params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna a lista paginada de idiomas configurados para a prova informada, com o nome do idioma em português como rótulo de exibição. **(Requer Authorization para autenticação)**
 * @summary Listar idiomas de uma prova (Requer Authorization para autenticação)
 * {@link /api/v1/exam/:examId/langs}
 */
export function useGetApiV1ExamExamidLangs<
  TData = GetApiV1ExamExamidLangsQueryResponse,
  TQueryData = GetApiV1ExamExamidLangsQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamExamidLangsQueryKey,
>(
  examId: GetApiV1ExamExamidLangsPathParams["examId"],
  params?: GetApiV1ExamExamidLangsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamExamidLangsQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamExamidLangs401
          | GetApiV1ExamExamidLangs404
          | GetApiV1ExamExamidLangs500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ExamExamidLangsQueryKey(examId, params);

  const query = useQuery(
    {
      ...getApiV1ExamExamidLangsQueryOptions(examId, params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ExamExamidLangs401
      | GetApiV1ExamExamidLangs404
      | GetApiV1ExamExamidLangs500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
